import React from 'react';

const StatusBadge = ({ variant, children }) => {
  const styles = {
    pending: 'bg-amber-50 text-amber-800 border-amber-200',
    success: 'bg-green-50 text-green-800 border-green-200',
    failure: 'bg-red-50 text-red-800 border-red-200',
  };

  return (
    <div className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-semibold ${styles[variant] || styles.pending}`}>
      {children}
    </div>
  );
};

const StatusIcon = ({ status }) => {
  if (status === 'success') {
    return (
      <svg viewBox="0 0 20 20" className="h-4 w-4 text-green-600" fill="currentColor" aria-hidden="true">
        <path
          fillRule="evenodd"
          d="M16.707 5.293a1 1 0 0 1 0 1.414l-7.2 7.2a1 1 0 0 1-1.414 0l-3.6-3.6a1 1 0 1 1 1.414-1.414l2.893 2.893 6.493-6.493a1 1 0 0 1 1.414 0Z"
          clipRule="evenodd"
        />
      </svg>
    );
  }

  if (status === 'failure') {
    return (
      <svg viewBox="0 0 20 20" className="h-4 w-4 text-red-600" fill="currentColor" aria-hidden="true">
        <path
          fillRule="evenodd"
          d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm2.707-10.707a1 1 0 0 0-1.414-1.414L10 7.172 8.707 5.879a1 1 0 0 0-1.414 1.414L8.586 8.586 7.293 9.879a1 1 0 1 0 1.414 1.414L10 10.0l1.293 1.293a1 1 0 0 0 1.414-1.414l-1.293-1.293 1.293-1.293Z"
          clipRule="evenodd"
        />
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 20 20" className="h-4 w-4 text-amber-600" fill="currentColor" aria-hidden="true">
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm1-12a1 1 0 1 0-2 0v4a1 1 0 1 0 2 0V6Zm-1 9a1.25 1.25 0 1 0 0-2.5A1.25 1.25 0 0 0 10 15Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default function PaymentStatus({ status, message }) {
  if (status === 'success') {
    return (
      <div className="space-y-2">
        <div className="flex items-center justify-between gap-3">
          <StatusBadge variant="success"><StatusIcon status="success" /> Succès</StatusBadge>
        </div>
        {message ? <p className="text-sm text-gray-700 leading-relaxed">{message}</p> : null}
      </div>
    );
  }

  if (status === 'failure') {
    return (
      <div className="space-y-2">
        <div className="flex items-center justify-between gap-3">
          <StatusBadge variant="failure"><StatusIcon status="failure" /> Échec</StatusBadge>
        </div>
        {message ? <p className="text-sm text-gray-700 leading-relaxed">{message}</p> : null}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between gap-3">
        <StatusBadge variant="pending"><StatusIcon status="pending" /> En attente</StatusBadge>
      </div>
      {message ? <p className="text-sm text-gray-700 leading-relaxed">{message}</p> : null}
    </div>
  );
}
